import { render, staticRenderFns } from "./assettemplates.html?vue&type=template&id=3b08a9f2&external"
import script from "./assettemplates.vue?vue&type=script&lang=js"
export * from "./assettemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports